import React, { useState } from "react";
import { AddFlex } from "../../../reusableStyles";
import OfferingCardHeader from "./OfferingCardHeader";
import OfferingCardBody from "./OfferingCardBody";
import OfferingCardFooter from "./OfferingCardFooter";
import useWindowSize from "../../../Hooks/useWindowSize";
import {
  Currency,
  FeaturesKeys,
  Status,
  formatPrice,
  isArrayNullOrUndefined,
  isNullOrUndefined,
} from "../../../utils";
import { enqueueSnackbar } from "notistack";
import { userFeatureApi } from "../../../Store/UserFeaturesSlice";
import { useDispatch } from "react-redux";
import { UpdateFeature } from "../../../Api/ApiEndPoints";

function OfferingCard({
  revenueStats,
  offering,
  isLast,
  ticketWiseStats,
  featureKey,
  showSalesDetails,
  loading,
  ref,
}) {
  const isPublished =
    offering.status === Status.LIVE || offering.status === Status.PUBLISHED;
  const { isMobileView } = useWindowSize();
  const dispatch = useDispatch();
  const [isApiSuccess, setIsApiSuccess] = useState(false);
  const getPriceText = () => {
    let priceText = "";
    if (featureKey.id === FeaturesKeys.travel.id) {
      priceText =
        "From " +
        formatPrice(
          offering?.scheduleDetails[0]?.tickets[0]?.prices[
            offering.primaryCurrency
          ],
          offering.primaryCurrency
        );
    } else if (featureKey.id === FeaturesKeys.oneonone.id) {
      priceText =
        "From " +
        formatPrice(
          isNullOrUndefined(offering?.scheduleDetails[0]?.tickets)
            ? 0
            : offering?.scheduleDetails[0]?.tickets[0]?.prices[
                offering.primaryCurrency
              ],
          offering.primaryCurrency
        );
    } else {
      priceText =
        "From " +
        formatPrice(
          offering?.scheduleDetails[0]?.timeSlots[0]?.tickets[0]?.prices[
            offering.primaryCurrency
          ],
          offering.primaryCurrency
        );
    }
    return priceText;
  };
  const getStartTimeSlot = () => {
    if (isArrayNullOrUndefined(offering.scheduleDetails)) return "";
    if (
      FeaturesKeys.travel.id === featureKey.id ||
      FeaturesKeys.oneonone.id === featureKey.id
    )
      return;
    return offering.scheduleDetails[0].timeSlots[0]?.time;
  };
  const getRevenue = () => {
    if (isNullOrUndefined(revenueStats?.revenue)) return 0;
    const revenue = revenueStats.revenue[offering.id]?.totalRevenue
      ? revenueStats.revenue[offering.id]?.totalRevenue
      : 0;
    return formatPrice(revenue, Currency.INR);
  };

  const getTotalSold = () => {
    if (isNullOrUndefined(revenueStats?.revenue)) return 0;
    return revenueStats.revenue[offering.id]?.totalSales
      ? revenueStats.revenue[offering.id]?.totalSales
      : 0;
  };

  const handlePublishUnpublishOffering = (setLoading) => {
    setLoading(true);
    const newOffering = {
      ...offering,
      status: !isPublished ? Status.PUBLISHED : Status.UNPUBLISHED,
    };
    dispatch(
      userFeatureApi({
        payload: {
          action: "update",
          itemData: newOffering,
          featureId: featureKey.id,
        },
        endpoint: UpdateFeature,
      })
    ).then((actionResult) => {
      if (actionResult.meta.requestStatus === "fulfilled") {
        setLoading(false);
        const snackbarText = `Your offering is ${
          isPublished ? "UNPUBLISHED" : "PUBLISHED"
        }`;
        if (!isPublished) {
          setIsApiSuccess(true);
        }
        enqueueSnackbar(snackbarText, {
          variant: "success",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
          },
        });
      } else if (actionResult.meta.requestStatus === "rejected") {
        setLoading(false);
        enqueueSnackbar("Something went wrong", {
          variant: "success",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
          },
        });
      }
    });
  };

  return (
    offering &&
    !isNullOrUndefined(offering.scheduleDetails) && (
      <AddFlex
        flexDirection="column"
        width={isMobileView() || isLast ? "100%" : "30%"}
        padding="20px 16px"
        borderRadius="8px"
        gap="16px"
        backgroundColor="white"
        style={{ boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)" }}
      >
        <OfferingCardHeader
          featureKey={featureKey}
          handlePublishUnpublishOffering={handlePublishUnpublishOffering}
          offering={offering}
          isPublished={
            offering.status === Status.LIVE ||
            offering.status === Status.PUBLISHED
          }
        />

        <OfferingCardBody
          featureKey={featureKey}
          name={offering.name}
          loadingStats={loading}
          offeringId={offering.id}
          scheduleDetails={offering.scheduleDetails}
          coverImage={offering.coverImage}
          priceText={getPriceText()}
          revenueStats={revenueStats}
          startDate={offering.scheduleDetails[0]?.date}
          endDate={offering.scheduleDetails[0]?.endDate}
          startTimeSlot={getStartTimeSlot()}
          revenue={getRevenue()}
          sold={getTotalSold()}
          isSaleDetailsClicked={showSalesDetails}
        />

        {/* {isOfferingPublishable(offering, featureKey.name.toLowerCase()) && (
          <Gap />
        )} */}
        <OfferingCardFooter
          loadingStats={loading}
          offering={offering}
          handlePublishUnpublishOffering={handlePublishUnpublishOffering}
          sold={getTotalSold()}
          featureKey={featureKey}
        />
      </AddFlex>
    )
  );
}

export default OfferingCard;
